import { makeStyles } from "@remo-co/ui-core";

export const useStyles = makeStyles((theme) => ({
  container: {
    flexDirection: "column",
    padding: "10px 12px",
    borderRight: `1px solid ${theme.palette.gray.light}`,
  },
}));
